import React from "react";
import { useTranslation } from "react-i18next";

import Timestamp from "./Timestamp";
import Title from "./Title";

import { Spacer } from "@/components/common";

type Props = {
  title: string;
  timestamp?: string;
  onClickDetail: () => void;
};

const Header: React.FC<Props> = ({ title, timestamp, onClickDetail }) => {
  const { t } = useTranslation();

  return (
    <div className="progress-notification-header">
      <div className="flex items-center">
        <Title data={title} />
        <Spacer x="10px" />
        <a style={{ textDecorationLine: "underline" }} onClick={onClickDetail}>
          ▶&nbsp;{t("detailBtn")}
        </a>
      </div>
      <Timestamp data={timestamp} />
    </div>
  );
};

export default Header;
